import { getContent } from '@/services/contentful'
import { Content } from '@/services/contentful/types'
import { contentUtil } from '@/utils'

export async function getStaticProps() {
  const entry = await getContent({
    content_type: 'pageApplyToFund',
    'fields.slug': 'apply',
  })

  const content = entry.items[0] as Content

  const mapped = contentUtil.mapContentRecursive(content) as unknown as {
    heading: string
    subheading: string
  }

  const props = {
    seo: content.fields.seo.fields,
    content: {
      ...mapped,
      // This is a hack to get line breaks on the hero copy
      // since I wasn't able to do so in Contentful
      heading: mapped.heading.replace('<br>', '\n'),
      subheading: mapped.subheading.replace('<br>', '\n'),
    },
  }

  return {
    props,
  }
}

export { default } from '@/components/pages/apply/ApplyPage'
